import React, { useState } from 'react'
import styled from 'styled-components';
import ProjectCard from '../components/Card/projectCard';
import { projects } from '../data/constants';
import { useLanguage } from '../utils/LanguageContext';

const Container = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
position: relative;
z-index: 1;
padding: 80px 0px;

@media (max-width: 768px) {
  padding: 40px 0px;
}
`;

const Wrapper = styled.div`
  max-width: 1100px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 12px;
`;

const Title = styled.h1`
font-size: 42px;
font-weight: 700;
text-align: center;
margin-top: 20px;
color: ${({ theme }) => theme.text_primary};

@media (max-width: 768px) {
  margin-top: 12px;
  font-size: 32px;
}
`;

const Desc = styled.div`
font-size: 18px;
max-width: 600px;
text-align: center;
color: ${({ theme }) => theme.text_secondary};
padding: 0 16px;

@media (max-width: 768px) {
  font-size: 16px;
}
`;

const ToggleGroup = styled.div`
display: flex;
border: 1.5px solid ${({ theme }) => theme.primary};
color: ${({ theme }) => theme.primary};
font-size: 16px;
border-radius: 12px;
font-weight: 500;
margin: 22px 0;

@media (max-width: 768px) {
    font-size: 12px;
    flex-wrap: wrap;
    border-radius: 8px;
}
`;

const ToggleButton = styled.div`
    padding: 8px 18px;
    cursor: pointer;
    border-radius: 6px;
    ${({ active, theme }) => active && `background-color: ${theme.primary + 20};`}

    &:hover {
        background-color: ${({ theme }) => theme.primary + 8};
    }

    @media (max-width: 768px) {
        padding: 6px 10px;
        border-radius: 4px;
    }
`;

const Divider = styled.div`
    width: 1.5px;
    background-color: ${({ theme }) => theme.primary};
`;

const CardContainer = styled.div`
display: flex;
justify-content: center;
align-items: stretch;
flex-wrap: wrap;
gap: 28px;

@media (max-width: 768px) {
  flex-wrap: nowrap;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  justify-content: flex-start;
  padding: 0 20px 12px 25px;
  width: 100%;
  gap: 16px;
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.primary + '60'} transparent;

  &::-webkit-scrollbar {
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.primary + '60'};
    border-radius: 4px;
  }
}
`;

const CardWrapper = styled.div`
@media (max-width: 768px) {
  scroll-snap-align: start;
  flex-shrink: 0;
  width: 85vw;
  max-width: 340px;
  display: flex;
}
`;

const Projects = ({ openModal, setOpenModal }) => {
  const [toggle, setToggle] = useState("all");
  const { t } = useLanguage();

  const filteredProjects = toggle === "all"
    ? projects
    : projects.filter((item) => item.category === toggle);

  return (
    <Container id="projects">
      <Wrapper>
        <Title>{t.projectsTitle}</Title>
        <Desc>{t.projectsDesc}</Desc>

        <ToggleGroup>
          <ToggleButton active={toggle === "all"} onClick={() => setToggle('all')}>
            {t.allProjects}
          </ToggleButton>
          <Divider />
          <ToggleButton active={toggle === "android app"} onClick={() => setToggle('android app')}>
            {t.mobileProjects}
          </ToggleButton>
          <Divider />
          <ToggleButton active={toggle === "web app"} onClick={() => setToggle('web app')}>
            {t.webProjects}
          </ToggleButton>
          <Divider />
          <ToggleButton active={toggle === "open source"} onClick={() => setToggle('open source')}>
            {t.openSource}
          </ToggleButton>
          <Divider />
          <ToggleButton active={toggle === "other"} onClick={() => setToggle('other')}>
            {t.otherProjects}
          </ToggleButton>
        </ToggleGroup>

        <CardContainer>
          {filteredProjects.map(project => (
            <CardWrapper key={project.id}>
              <ProjectCard
                project={project}
                openModal={openModal}
                setOpenModal={setOpenModal}
              />
            </CardWrapper>
          ))}
        </CardContainer>
      </Wrapper>
    </Container>
  )
}

export default Projects
